module.exports = __webpack_public_path__ + "static/media/slider-home-start-ups-slide-01-bg.20145923.jpg";